import InitialState from '../initial-state';
import * as ActionNames from '../action-names';

export default function reducer(
  state = InitialState.getState().menu,
  { type, payload }
) {
  switch (type) {
    case ActionNames.SET_MENU_MAPPINGS: {
      return {
        ...state,
        mappings: payload
      };
    }
    default:
      return state;
  }
}
